import React, {memo} from 'react';
import {ItemList} from '../ItemList';
import {useFilterSelector} from '../../hooks/filter-selector';

export const ControlRenderer = memo(function ControlRenderer(props: { controlTypeId: string }) {
    const controls = useFilterSelector(
        state => state.control.controlList,
        c => c.type_id === props.controlTypeId,
    );

    return (
        <ItemList controls={controls}/>
    );
});
